import request from 'sb-request'
import { reducers } from 'redux/core'

import quizRecommendationsQuery from './quizRecommendations.graphql'


const fetchQuizRecommendations = () =>
  request.post('graphql?name=quizRecommendations', {
    body: {
      query: quizRecommendationsQuery,
    },
    modifyResult: ({ quizRecommendations }) => quizRecommendations,
  })
    .then((items) => {
      reducers.view.quizRecommendationsPage.setItems(items)

      return items
    })

const toggleSelectedId = (id) => reducers.view.quizRecommendationsPage.toggleSelectedId(id)

const resetSelectedIds = () => reducers.view.quizRecommendationsPage.resetSelectedIds()


export default {
  fetchQuizRecommendations,
  toggleSelectedId,
  resetSelectedIds,
}
